// extracted by mini-css-extract-plugin
module.exports = {"priceInput":"PriceInput_priceInput__2wAMi"};